import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'antd/lib/table';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
import ListCategoryRounds from './ListCategoryRounds';
var tableStyles = require('src/imports/styles/extend.table.scss');
var columns = [{
        title: 'Category name',
        dataIndex: 'name',
        key: 'name',
        sorter: function (a, b) { return (a.name).localeCompare(b.name); },
        render: function (name, category) { return (React.createElement(Link, { to: "categories/" + category.id }, name)); },
    }, {
        title: 'Type',
        dataIndex: 'isTeamCategory',
        key: 'isTeamCategory',
        className: tableStyles.colCenter,
        render: function (isTeam) { return isTeam ? 'Team' : 'Individual'; },
    }, {
        title: 'Qty Athletes',
        dataIndex: 'athleteCount',
        key: 'athleteCount',
        sorter: function (a, b) { return (a.athleteCount) > (b.athleteCount) ? 1 : (a.athleteCount) === (b.athleteCount) ? 0 : -1; },
        className: tableStyles.colCenter,
    }];
var ListCategory = function (props) {
    props.categories.sort(function (a, b) { return (a.name).localeCompare(b.name); });
    return (React.createElement(Table, { rowKey: 'id', columns: columns, dataSource: props.categories, expandedRowRender: function (category) { return React.createElement(ListCategoryRounds, { category: category, rounds: props.rounds }); }, locale: { emptyText: 'No categories in event' }, pagination: { pageSize: 50 } }));
};
export default ListCategory;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListCategoryPage/ListCategory.tsx
// module id = 1085
// module chunks = 0